// extracted by mini-css-extract-plugin
module.exports = {"makeReviewPage":"style-module--makeReviewPage--1kbU3","title":"style-module--title--1CnXu"};